/**
 * Created by Administrador on 24/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('baseRatePassages', {
                parent: 'app',
                url: '/baseRatePassages',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "50"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRatePassage/baseRatePassages.html',
                        controller: 'baseRatePassagesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            taxes: ['taxService', function(taxService){
                                return taxService.getTaxesList();
                            }],
                            baseRates: ['baseRateService','$stateParams',function(baseRateService,$stateParams){
                                return baseRateService.getBaseRates($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('baseRatePassageEdit', {
                parent: 'app',
                url: '/baseRatePassage/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRatePassage/baseRatePassageEdit.html',
                        controller: 'baseRatePassageEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            baseRate: ['baseRateService','$stateParams', function(baseRateService,$stateParams){
                                return baseRateService.getBaseRate($stateParams.id);
                            }]
                        }
                    }
                }
            });
    }
})();
